<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>
							<div
								class="modal-header row"
								style="justify-content: flex-end;"
							>
								<!-- <div class="col-6">
									<button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
								</div> -->
								<div class="col">
									<button
										type="button"
										class="close"
										@click="$emit('closeModal')"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
							</div>

							<div class="modal-body">
								<div>
									<h5>Catatan Tanggal Print Kwitansi</h5>
									<table class="table table-bordered" v-if="historical">
										<thead class="thead-dark">
											<th>Nomor Kwitansi</th>
											<th>Waktu Print</th>
										</thead>
										<tbody v-for="row in historical" :key="row.unique_code">
											<td>{{row.unique_code}}</td>
											<td>{{moment(row.created_at).format('MMM DD, Y HH:mm')}}</td>
										</tbody>
									</table>
								</div>
								<div class="text-center mt-4">
									<button class="btn btn-primary mr-3" @click="paymentPage()">Ke Halaman Pembayaran</button>
									<button class="btn btn-danger" @click="$emit('closeModal')">Keluar</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
			</div>
		</div>
	</transition>
</template>

<script>
import moment from "moment";
export default {
	data() {
		return {
			moment,
			mobile: this.isMobile(),
			historical : null
		};
	},
	props: ["work_order_code"],
	mounted() {
		this.loadKwitansiHistory()
	},
	methods: {
		loadKwitansiHistory () {
			let wo = this.work_order_code.split('"').join('')
			this.$http.get(`/api/v1/workorder/print/historical?form_code=${wo}`)
			.then((resp) => {
				this.historical = resp.data.data
			})
			.catch((err)=> {
				console.log(err)
			})
		},
		paymentPage () {
			this.$router.push({ name : 'FinanceWorkOrderPayment', query : { form_code : this.work_order_code.split('"').join('') , from : 'ReportInsurance' } })
		}
	},
};
</script>

<style scoped>
/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
		#TITLE made by Colorlib (https://colorlib.com)
		========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}

table thead tr th,
table tbody tr td {
	text-align: center;
	vertical-align: middle;
}
</style>
